// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteLayout_wrapper__1ENrw"};